'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import ImageModal from './ImageModal';

interface FoodImage {
  id: number;
  src: string;
  alt: string;
  title: string;
  category: string;
  description: string;
}

export default function FoodGalleryGrid() {
  const [selectedImage, setSelectedImage] = useState<FoodImage | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const foodImages: FoodImage[] = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1637964144787-cbb7bba0baca",
    alt: "Golden crispy broasted chicken pieces with herbs on white plate",
    title: "Signature Broasted Chicken",
    category: "broast",
    description: "Our signature crispy broasted chicken with secret spice blend"
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1605291581998-f646dd126837",
    alt: "Spicy buffalo chicken wings with celery sticks and blue cheese dip",
    title: "Buffalo Wings Platter",
    category: "wings",
    description: "Fiery buffalo wings with cooling ranch dip"
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1727906804946-52835c73200a",
    alt: "Grilled chicken shawarma wrap with vegetables and tahini sauce",
    title: "Chicken Shawarma Wrap",
    category: "arabian",
    description: "Authentic Arabian shawarma with garlic sauce"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1692737348416-0a4fa4cf1523",
    alt: "Crispy chicken burger with lettuce tomato and special sauce",
    title: "Crispy Chicken Burger",
    category: "burgers",
    description: "Juicy chicken patty with fresh vegetables"
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1701540747631-8f449f32dbc8",
    alt: "Chicken biryani with raita and boiled egg in traditional pot",
    title: "Chicken Biryani Special",
    category: "rice",
    description: "Aromatic biryani with tender chicken pieces"
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1680359873963-32b51c171ef5",
    alt: "Grilled chicken kebabs on skewers with mint chutney",
    title: "Chicken Kebab Platter",
    category: "arabian",
    description: "Smoky grilled kebabs with traditional spices"
  },
  {
    id: 7,
    src: "https://images.unsplash.com/photo-1615719413546-198b25453f85",
    alt: "Chicken tikka pizza with bell peppers and onions",
    title: "Chicken Tikka Pizza",
    category: "fusion",
    description: "Indo-fusion pizza with tandoori chicken"
  },
  {
    id: 8,
    src: "https://images.unsplash.com/photo-1654683414629-9a8dbd15bcf0",
    alt: "Crispy chicken tenders with honey mustard dipping sauce",
    title: "Chicken Tenders Combo",
    category: "tenders",
    description: "Perfectly breaded chicken strips"
  },
  {
    id: 9,
    src: "https://images.unsplash.com/photo-1570552372456-ce71bb699e48",
    alt: "Spicy chicken wings with sesame seeds and green onions",
    title: "Asian Glazed Wings",
    category: "wings",
    description: "Sweet and spicy Asian-style wings"
  },
  {
    id: 10,
    src: "https://images.unsplash.com/photo-1613552496228-7992da79837d",
    alt: "Whole roasted chicken with herbs and roasted vegetables",
    title: "Herb Roasted Chicken",
    category: "broast",
    description: "Whole chicken roasted to perfection"
  },
  {
    id: 11,
    src: "https://images.unsplash.com/photo-1627662055469-179b03a4a763",
    alt: "Chicken nuggets with ketchup and barbecue sauce",
    title: "Crispy Chicken Nuggets",
    category: "tenders",
    description: "Kid-friendly chicken nuggets"
  },
  {
    id: 12,
    src: "https://images.unsplash.com/photo-1718509820329-e6b512706178",
    alt: "Chicken fried rice with vegetables and egg in bowl",
    title: "Chicken Fried Rice",
    category: "rice",
    description: "Wok-tossed fried rice with chicken"
  }];


  const categories = [
  { id: 'all', label: 'All Items', icon: 'Squares2X2Icon' },
  { id: 'broast', label: 'Broasted', icon: 'FireIcon' },
  { id: 'wings', label: 'Wings', icon: 'SparklesIcon' },
  { id: 'arabian', label: 'Arabian', icon: 'GlobeAltIcon' },
  { id: 'burgers', label: 'Burgers', icon: 'ShoppingBagIcon' },
  { id: 'rice', label: 'Rice Bowls', icon: 'CakeIcon' }];


  const filteredImages = selectedCategory === 'all' ?
  foodImages :
  foodImages.filter((img) => img.category === selectedCategory);

  return (
    <>
      <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:135:6" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="135" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-8%22%7D" className="space-y-8">
        {/* Category Filter */}
        <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:137:8" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="137" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20items-center%20justify-center%20gap-3%22%7D" className="flex flex-wrap items-center justify-center gap-3">
          {categories.map((category) =>
          <button data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:139:10" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="139" data-component-file="FoodGalleryGrid.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={category.id}
            onClick={() => setSelectedCategory(category.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-full font-body font-body-medium transition-smooth ${
            selectedCategory === category.id ?
            'bg-secondary text-secondary-foreground shadow-brand' :
            'bg-card text-text-secondary hover:bg-muted hover:text-primary border border-border'}`
            }>

              <Icon data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:148:14" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="148" data-component-file="FoodGalleryGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={category.icon as any} size={18} />
              <span data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:149:14" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="149" data-component-file="FoodGalleryGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{category.label}</span>
            </button>
          )}
        </div>

        {/* Image Grid */}
        <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:155:8" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="155" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20xl%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredImages.map((image) =>
          <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:157:10" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="157" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22group%20relative%20bg-card%20rounded-lg%20overflow-hidden%20shadow-brand%20hover%3Ashadow-brand-hover%20transition-smooth%20cursor-pointer%22%7D"
            key={image.id}
            onClick={() => setSelectedImage(image)}
            className="group relative bg-card rounded-lg overflow-hidden shadow-brand hover:shadow-brand-hover transition-smooth cursor-pointer">

              <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:162:14" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="162" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22aspect-square%20overflow-hidden%22%7D" className="aspect-square overflow-hidden">
                <AppImage data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:163:16" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="163" data-component-file="FoodGalleryGrid.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20group-hover%3Ascale-110%20transition-smooth%22%7D"
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-smooth" />

              </div>
              
              <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:170:14" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="170" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-t%20from-primary%2F90%20via-primary%2F50%20to-transparent%20opacity-0%20group-hover%3Aopacity-100%20transition-smooth%20flex%20items-end%22%7D" className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/50 to-transparent opacity-0 group-hover:opacity-100 transition-smooth flex items-end">
                <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:171:16" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="171" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-4%20text-primary-foreground%20w-full%22%7D" className="p-4 text-primary-foreground w-full">
                  <h3 data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:172:18" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="172" data-component-file="FoodGalleryGrid.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20font-headline-bold%20text-lg%20mb-1%22%7D" className="font-headline font-headline-bold text-lg mb-1">{image.title}</h3>
                  <p data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:173:18" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="173" data-component-file="FoodGalleryGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-sm%20opacity-90%22%7D" className="font-body text-sm opacity-90">{image.description}</p>
                </div>
              </div>

              <div data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:177:14" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="177" data-component-file="FoodGalleryGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-3%20right-3%20bg-primary%2F80%20backdrop-blur-sm%20text-primary-foreground%20px-3%20py-1%20rounded-full%20opacity-0%20group-hover%3Aopacity-100%20transition-smooth%22%7D" className="absolute top-3 right-3 bg-primary/80 backdrop-blur-sm text-primary-foreground px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-smooth">
                <Icon data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:178:16" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="178" data-component-file="FoodGalleryGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassPlusIcon%22%7D" name="MagnifyingGlassPlusIcon" size={16} />
              </div>
            </div>
          )}
        </div>
      </div>

      {selectedImage &&
      <ImageModal data-component-id="src/app/gallery/components/FoodGalleryGrid.tsx:186:6" data-component-path="src/app/gallery/components/FoodGalleryGrid.tsx" data-component-line="186" data-component-file="FoodGalleryGrid.tsx" data-component-name="ImageModal" data-component-content="%7B%22elementName%22%3A%22ImageModal%22%7D"
        image={selectedImage}
        onClose={() => setSelectedImage(null)} />

      }
    </>);

}